/**
 * @group Data
 * @summary Action verbs for API operations
 * 
 * @remarks
 * This constant contains action verbs used to dynamically build operation descriptions
 * for logging and error messages in API operations.
 * 
 * @example
 * ```typescript
 * import { API_ACTION_VERBS } from '@shared/constants';
 * 
 * const operation = `${API_ACTION_VERBS.FETCHING} users`;
 * logger.info(`Starting ${operation}`);
 * 
 * try {
 *   const users = await fetchUsers();
 *   logger.info(`Completed ${operation}`);
 * } catch (error) {
 *   logger.error(`Error ${operation}:`, error);
 * }
 * ```
 */
export const API_ACTION_VERBS = {
  FETCHING: 'fetching',
  CREATING: 'creating',
  UPDATING: 'updating',
  DELETING: 'deleting'
} as const; 